export const getCategoryColor = (category: string) => {
  const lower = category.toLowerCase();
  if (lower === 'akademik') return 'text-[#19e65e] bg-[#19e65e]/10'; // Primary
  if (lower === 'kegiatan' || lower === 'kajian') return 'text-indigo-600 bg-indigo-100';
  if (lower === 'pengumuman' || lower === 'informasi') return 'text-orange-600 bg-orange-100';
  if (lower === 'prestasi') return 'text-teal-600 bg-teal-100';
  return 'text-gray-600 bg-gray-100';
};
